import { notify } from "../components/Toast.jsx";
// Reconstructed from the supplied production build; original component names were unavailable.
import {
  CircleAlertIcon,
  ClockIcon,
  MapPinIcon,
  PackageIcon,
  React,
  TruckIcon,
  jsxRuntime,
  motion,
  useNavigate,
  useParams,
} from "../vendor/runtime.js";
import { useAuth } from "../context/AuthContext.jsx";
import { SERVER_URL } from "../config.js";
import { api } from "../api/client.js";
import { Navbar } from "../components/Navbar.jsx";
import { Button } from "../components/Button.jsx";
import { ProductSupportChat } from "../components/ProductSupportChat.jsx";
import { CertificateRequestCard } from "../components/CertificateRequestCard.jsx";
const PurchaseDetailsPage = () => {
  var W;
  const { purchaseId: a } = useParams(),
    [n, i] = React.useState(null),
    [l, c] = React.useState(true),
    [u, m] = React.useState(null),
    [f, x] = React.useState({
      project: "idle",
      report: "idle",
    }),
    [p, g] = React.useState(false),
    b = useNavigate(),
    { currentUser: y } = useAuth(),
    w = SERVER_URL,
    N = (B) =>
      B
        ? B.split(
            `
`,
          )
            .filter((G) => G.trim() !== "")
            .map((G) => {
              const te = G.split(":");
              return {
                question: te[0].trim(),
                answer: te.slice(1).join(":").trim(),
              };
            })
        : [],
    T = (B) => {
      switch (B == null ? undefined : B.toLowerCase()) {
        case "order received":
          return {
            color: "from-blue-500 to-blue-600",
            bgColor: "bg-blue-50",
            textColor: "text-blue-700",
            borderColor: "border-blue-200",
            text: "Order Received",
            description: "Your order has been received and is being prepared.",
            icon: PackageIcon,
          };
        case "in process":
          return {
            color: "from-yellow-500 to-yellow-600",
            bgColor: "bg-yellow-50",
            textColor: "text-yellow-700",
            borderColor: "border-yellow-200",
            text: "Processing",
            description: "Your order is currently being processed and prepared for shipment.",
            icon: ClockIcon,
          };
        case "shipped":
          return {
            color: "from-purple-500 to-purple-600",
            bgColor: "bg-purple-50",
            textColor: "text-purple-700",
            borderColor: "border-purple-200",
            text: "Shipped",
            description: "Your order has been shipped and is on its way to you.",
            icon: TruckIcon,
          };
        case "out for delivery":
          return {
            color: "from-orange-500 to-orange-600",
            bgColor: "bg-orange-50",
            textColor: "text-orange-700",
            borderColor: "border-orange-200",
            text: "Out for Delivery",
            description: "Your package is out for delivery and will arrive soon.",
            icon: MapPinIcon,
          };
        case "delivered":
          return {
            color: "from-green-500 to-green-600",
            bgColor: "bg-green-50",
            textColor: "text-green-700",
            borderColor: "border-green-200",
            text: "Delivered",
            description: "Your order has been successfully delivered.",
            icon: PackageIcon,
          };
        default:
          return {
            color: "from-gray-500 to-gray-600",
            bgColor: "bg-gray-50",
            textColor: "text-gray-700",
            borderColor: "border-gray-200",
            text: "Unknown Status",
            description: "Status information is not available.",
            icon: CircleAlertIcon,
          };
      }
    };
  (React.useEffect(() => {
    a &&
      (async () => {
        try {
          console.log("Fetching purchase details for ID:", a);
          const G = await api.get(`/purchases/${a}`);
          (console.log("Purchase details response:", G.data), i(G.data));
        } catch (G) {
          (console.error("Error fetching purchase details:", G),
            G.response && G.response.status === 404
              ? m("This purchase was not found or you do not have access to it.")
              : m("Failed to load purchase details. Please try again later."));
        } finally {
          c(false);
        }
      })();
  }, [a]),
    React.useEffect(() => {
      (async () => {
        if (n && n.product_id && (!n.features || !n.language))
          try {
            const ne = (await api.get(`${api.defaults.baseURL}/products`)).data.find(
              (de) => de.id === parseInt(n.product_id),
            );
            ne &&
              i((de) => ({
                ...de,
                ...ne,
                id: de.id,
                purchase_date: de.purchase_date || ne.created_at,
              }));
          } catch (G) {
            console.error("Error fetching product details:", G);
          }
      })();
    }, [n]));
  const C = async (B) => {
      const G = B === "project" ? "project" : "report";
      x((te) => ({
        ...te,
        [G]: "loading",
      }));
      try {
        if (B === "project" && !n.project_file)
          throw new Error("Project file not available for this purchase");
        if (B === "report" && !n.report_file)
          throw new Error("Report file not available for this purchase");
        // Always go through the authenticated backend endpoint (it resolves the
        // stored file path, verifies the purchase belongs to this user, and logs
        // the download) rather than guessing a public URL from the raw file path.
        const te = `${w}/api/purchases/${a}/download/${B}`;
        const Ce = document.createElement("a");
        ((Ce.href = te),
          (Ce.target = "_blank"),
          (Ce.rel = "noopener"),
          document.body.appendChild(Ce),
          Ce.click(),
          document.body.removeChild(Ce),
          x((we) => ({
            ...we,
            [G]: "success",
          })),
          setTimeout(() => {
            x((we) => ({
              ...we,
              [G]: "idle",
            }));
          }, 3e3));
      } catch (te) {
        (console.error(`Error downloading ${B} file:`, te),
          x((ne) => ({
            ...ne,
            [G]: "error",
          })),
          notify(
            `Failed to download ${B === "project" ? "project" : "report"} file. Please check if the file exists or contact support.`, "error", "Download unavailable",
          ),
          setTimeout(() => {
            x((ne) => ({
              ...ne,
              [G]: "idle",
            }));
          }, 3e3));
      }
    },
    A = (B, G) => {
      switch (B) {
        case "loading":
          return "Downloading...";
        case "success":
          return "Downloaded successfully!";
        case "error":
          return "Download failed";
        default:
          return `Download ${G}`;
      }
    },
    O = {
      hidden: {
        opacity: 0,
        y: 20,
      },
      visible: {
        opacity: 1,
        y: 0,
        transition: {
          duration: 0.5,
        },
      },
    },
    M = {
      hidden: {
        opacity: 0,
      },
      visible: {
        opacity: 1,
        transition: {
          staggerChildren: 0.1,
        },
      },
    },
    Y = n != null && n.faq ? N(n.faq) : [],
    R =
      ((W = n == null ? undefined : n.category) == null ? undefined : W.toLowerCase()) ===
      "hardware",
    U = R ? T(n == null ? undefined : n.delivery_status) : null;
  return (
    <div
      className={
        "min-h-screen bg-gradient-to-br from-slate-50 via-white to-slate-100 pb-8 sm:pb-12"
      }
    >
      <Navbar />
      <div className={"w-full  mx-auto px-4 sm:px-6 lg:px-8 pt-25 sm:pt-24 lg:pt-30 py-6 sm:py-8"}>
        <motion.button
          initial={{
            opacity: 0,
            x: -20,
          }}
          animate={{
            opacity: 1,
            x: 0,
          }}
          onClick={() => b("/my")}
          className={
            "inline-flex items-center mb-6 sm:mb-8 px-3 sm:px-4 py-2 text-cyan-700 hover:text-white hover:bg-cyan-700 border border-cyan-700 hover:border-cyan-900 rounded-lg sm:rounded-xl transition-all duration-300 font-medium text-sm sm:text-base"
          }
        >
          <svg
            className={"w-4 h-4 sm:w-5 sm:h-5 mr-2"}
            fill={"none"}
            stroke={"currentColor"}
            viewBox={"0 0 24 24"}
            xmlns={"http://www.w3.org/2000/svg"}
          >
            <path
              strokeLinecap={"round"}
              strokeLinejoin={"round"}
              strokeWidth={"2"}
              d={"M10 19l-7-7m0 0l7-7m-7 7h18"}
            />
          </svg>
          {"Back to My Purchases"}
        </motion.button>
        {l ? (
          <motion.div
            initial={{
              opacity: 0,
            }}
            animate={{
              opacity: 1,
            }}
            className={
              "bg-white rounded-2xl sm:rounded-3xl shadow-xl p-8 sm:p-12 text-center border border-slate-100"
            }
          >
            <div className={"relative w-16 h-16 sm:w-20 sm:h-20 mx-auto mb-4 sm:mb-6"}>
              <div className={"absolute inset-0 border-4 border-indigo-100 rounded-full"} />
              <div
                className={
                  "absolute inset-0 border-4 border-transparent border-t-indigo-600 rounded-full animate-spin"
                }
              />
            </div>
            <p className={"text-slate-600 font-medium text-base sm:text-lg"}>
              {"Loading purchase details..."}
            </p>
          </motion.div>
        ) : u ? (
          <motion.div
            initial={{
              opacity: 0,
              y: 20,
            }}
            animate={{
              opacity: 1,
              y: 0,
            }}
            className={
              "bg-white rounded-2xl sm:rounded-3xl shadow-xl overflow-hidden border border-red-100"
            }
          >
            <div className={"bg-gradient-to-r from-red-50 to-orange-50 p-6 sm:p-8"}>
              <div
                className={
                  "bg-red-100 rounded-full p-3 sm:p-4 w-12 h-12 sm:w-16 sm:h-16 flex items-center justify-center mx-auto mb-4 sm:mb-6"
                }
              >
                <svg
                  className={"w-6 h-6 sm:w-8 sm:h-8 text-red-600"}
                  fill={"none"}
                  stroke={"currentColor"}
                  viewBox={"0 0 24 24"}
                >
                  <path
                    strokeLinecap={"round"}
                    strokeLinejoin={"round"}
                    strokeWidth={"2"}
                    d={
                      "M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-2.5L13.732 4c-.77-.833-1.966-.833-2.732 0L4.082 16.5c-.77.833.192 2.5 1.732 2.5z"
                    }
                  />
                </svg>
              </div>
              <h3 className={"text-xl sm:text-2xl font-bold text-red-800 mb-3 sm:mb-4 text-center"}>
                {"Purchase Not Found"}
              </h3>
              <p
                className={
                  "text-red-700 mb-4 sm:mb-6 text-center max-w-md mx-auto text-sm sm:text-base"
                }
              >
                {u}
              </p>
              <p className={"text-red-600 text-center mb-6 sm:mb-8 text-sm sm:text-base"}>
                {"Please try again or contact support if the issue persists."}
              </p>
              <div className={"text-center"}>
                <Button
                  variant={"primary"}
                  onClick={() => b("/my")}
                  className={
                    "px-6 sm:px-8 py-2.5 sm:py-3 bg-red-600 hover:bg-red-700 text-white rounded-lg sm:rounded-xl font-medium text-sm sm:text-base"
                  }
                >
                  {"Return to My Purchases"}
                </Button>
              </div>
            </div>
          </motion.div>
        ) : n ? (
          <div className={"relative"}>
            <motion.div
              initial={{
                opacity: 0,
                y: 20,
              }}
              animate={{
                opacity: 1,
                y: 0,
              }}
              className={
                "bg-white rounded-2xl sm:rounded-3xl shadow-xl overflow-hidden border border-slate-100"
              }
            >
              <div
                className={
                  "bg-gradient-to-r from-cyan-500/10 via-blue-500/10 to-purple-500/10 bg-slate-900 relative overflow-hidden"
                }
              >
                <div className={"absolute inset-0 bg-black/10"} />
                <div className={"absolute inset-0"}>
                  <div
                    className={
                      "absolute top-0 right-1/4 w-48 h-48 sm:w-72 sm:h-72 bg-white/5 rounded-full blur-3xl"
                    }
                  />
                  <div
                    className={
                      "absolute bottom-0 left-1/4 w-64 h-64 sm:w-96 sm:h-96 bg-white/5 rounded-full blur-3xl"
                    }
                  />
                </div>
                <div className={"relative px-6 sm:px-8 py-8 sm:py-12"}>
                  <div
                    className={"flex flex-col sm:flex-row sm:items-start sm:justify-between gap-4"}
                  >
                    <div className={"flex-1"}>
                      <h1
                        className={
                          "text-2xl sm:text-3xl lg:text-4xl font-bold text-white mb-2 leading-tight"
                        }
                      >
                        {n.title}
                      </h1>
                      <p className={"text-indigo-100 text-base sm:text-lg"}>
                        {"Purchase ID: "}
                        {n.id}
                      </p>
                      <div className={"mt-3 sm:mt-4 flex flex-wrap gap-2"}>
                        <div
                          className={
                            "inline-flex items-center px-3 sm:px-4 py-1.5 sm:py-2 bg-white/10 backdrop-blur-sm rounded-full"
                          }
                        >
                          <div className={"w-2 h-2 bg-green-400 rounded-full animate-pulse mr-2"} />
                          <span className={"text-white text-xs sm:text-sm font-medium"}>
                            {"Active Purchase"}
                          </span>
                        </div>
                        <div
                          className={
                            "inline-flex items-center px-3 sm:px-4 py-1.5 sm:py-2 bg-white/10 backdrop-blur-sm rounded-full"
                          }
                        >
                          <span className={"text-white text-xs sm:text-sm font-medium"}>
                            {R ? "Hardware Project" : "Software Project"}
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              {R && U && (
                <motion.div
                  variants={O}
                  initial={"hidden"}
                  animate={"visible"}
                  className={"p-6 sm:p-8 border-b border-slate-100"}
                >
                  <div
                    className={`${U.bgColor} ${U.borderColor} border rounded-xl sm:rounded-2xl p-6 sm:p-8`}
                  >
                    <div className={"flex items-start gap-4 mb-4"}>
                      <div
                        className={`w-12 h-12 sm:w-16 sm:h-16 bg-gradient-to-r ${U.color} rounded-xl flex items-center justify-center flex-shrink-0`}
                      >
                        <U.icon className={"w-6 h-6 sm:w-8 sm:h-8 text-white"} />
                      </div>
                      <div className={"flex-1"}>
                        <h2 className={"text-xl sm:text-2xl font-bold text-slate-800 mb-2"}>
                          {"Delivery Status"}
                        </h2>
                        <div className={"flex items-center gap-3 mb-3"}>
                          <span
                            className={`px-3 py-1.5 rounded-full text-sm font-semibold ${U.bgColor} ${U.textColor}`}
                          >
                            {U.text}
                          </span>
                          <span className={"text-slate-500 text-sm"}>
                            {"Updated: "}
                            {n.purchase_date}
                          </span>
                        </div>
                        <p className={`${U.textColor} text-sm sm:text-base mb-4`}>
                          {U.description}
                        </p>
                      </div>
                    </div>
                    <div
                      className={"grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 sm:gap-6"}
                    >
                      <div className={"bg-white rounded-lg p-4 border border-slate-200"}>
                        <div className={"flex items-center gap-2 mb-2"}>
                          <PackageIcon className={"w-4 h-4 text-slate-500"} />
                          <span className={"text-sm font-medium text-slate-700"}>
                            {"Tracking Number"}
                          </span>
                        </div>
                        {n.tracking_no ? (
                          <p
                            className={
                              "font-mono text-sm text-slate-800 bg-slate-50 px-2 py-1 rounded"
                            }
                          >
                            {n.tracking_no}
                          </p>
                        ) : (
                          <p
                            className={
                              "text-sm text-amber-600 italic bg-amber-50 px-2 py-1 rounded"
                            }
                          >
                            {"Will be updated soon"}
                          </p>
                        )}
                      </div>
                      <div className={"bg-white rounded-lg p-4 border border-slate-200"}>
                        <div className={"flex items-center gap-2 mb-2"}>
                          <TruckIcon className={"w-4 h-4 text-slate-500"} />
                          <span className={"text-sm font-medium text-slate-700"}>
                            {"Shipping Company"}
                          </span>
                        </div>
                        {n.shipping_company ? (
                          <p className={"text-sm text-slate-800 font-medium"}>
                            {n.shipping_company}
                          </p>
                        ) : (
                          <p className={"text-sm text-amber-600 italic"}>
                            {"Will be updated soon"}
                          </p>
                        )}
                      </div>
                      <div className={"bg-white rounded-lg p-4 border border-slate-200"}>
                        <div className={"flex items-center gap-2 mb-2"}>
                          <MapPinIcon className={"w-4 h-4 text-slate-500"} />
                          <span className={"text-sm font-medium text-slate-700"}>
                            {"Delivery Type"}
                          </span>
                        </div>
                        <p className={"text-sm text-slate-800 font-medium"}>
                          {"Physical Hardware Delivery"}
                        </p>
                      </div>
                    </div>
                    {n.tracking_no ? (
                      <div className={"mt-6 flex justify-center"} />
                    ) : (
                      <div className={"mt-6 flex justify-center"}>
                        <div
                          className={
                            "inline-flex items-center px-6 py-3 bg-amber-100 text-amber-700 rounded-xl font-medium border border-amber-200"
                          }
                        >
                          <ClockIcon className={"w-4 h-4 mr-2"} />
                          {"Tracking details will be available soon"}
                        </div>
                      </div>
                    )}
                  </div>
                </motion.div>
              )}
              <div className={"p-6 sm:p-8"}>
                <motion.div
                  variants={M}
                  initial={"hidden"}
                  animate={"visible"}
                  className={"grid grid-cols-1 lg:grid-cols-3 gap-6 sm:gap-8 mb-8 sm:mb-10"}
                >
                  <motion.div variants={O} className={"lg:col-span-1"}>
                    <div className={"relative rounded-xl sm:rounded-2xl overflow-hidden shadow-lg"}>
                      <img
                        src={w + n.image}
                        alt={n.title + " by codebruh"}
                        className={"w-full h-auto  object-contain"}
                      />
                      <div
                        className={"absolute inset-0 bg-gradient-to-t from-black/20 to-transparent"}
                      />
                    </div>
                  </motion.div>
                  <motion.div variants={O} className={"lg:col-span-2 space-y-4 sm:space-y-6"}>
                    <div
                      className={
                        "bg-gradient-to-r from-slate-50 to-indigo-50 rounded-xl sm:rounded-2xl p-4 sm:p-6"
                      }
                    >
                      <div className={"flex items-center text-slate-600 mb-3 sm:mb-4"}>
                        <svg
                          className={"w-4 h-4 sm:w-5 sm:h-5 mr-2 sm:mr-3 text-indigo-500"}
                          fill={"none"}
                          stroke={"currentColor"}
                          viewBox={"0 0 24 24"}
                        >
                          <path
                            strokeLinecap={"round"}
                            strokeLinejoin={"round"}
                            strokeWidth={"2"}
                            d={
                              "M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z"
                            }
                          />
                        </svg>
                        <span className={"font-medium text-sm sm:text-base"}>
                          {"Purchased on: "}
                          {n.purchase_date}
                        </span>
                      </div>
                      <h2 className={"text-lg sm:text-xl font-bold text-slate-800 mb-2 sm:mb-3"}>
                        {"Description"}
                      </h2>
                      <p
                        className={
                          "text-slate-700 leading-relaxed whitespace-pre-line text-sm sm:text-base"
                        }
                      >
                        {n.description}
                      </p>
                    </div>
                    {(!R || n.project_file || n.report_file) && (
                      <motion.div
                        variants={O}
                        initial={"hidden"}
                        animate={"visible"}
                        className={"mb-8 sm:mb-10"}
                      >
                        <h2
                          className={
                            "text-xl sm:text-2xl font-bold text-slate-800 mb-4 sm:mb-6 flex items-center"
                          }
                        >
                          <span
                            className={
                              "w-6 h-6 sm:w-8 sm:h-8 bg-gradient-to-r from-green-500 to-blue-500 rounded-lg flex items-center justify-center mr-2 sm:mr-3"
                            }
                          >
                            <svg
                              className={"w-3 h-3 sm:w-4 sm:h-4 text-white"}
                              fill={"none"}
                              stroke={"currentColor"}
                              viewBox={"0 0 24 24"}
                            >
                              <path
                                strokeLinecap={"round"}
                                strokeLinejoin={"round"}
                                strokeWidth={"2"}
                                d={
                                  "M12 10v6m0 0l-3-3m3 3l3-3m2 8H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"
                                }
                              />
                            </svg>
                          </span>
                          {"Download Files"}
                        </h2>
                        {R && (
                          <div
                            className={"mb-4 p-4 bg-amber-50 border border-amber-200 rounded-lg"}
                          >
                            <div className={"flex items-center gap-2 mb-2"}>
                              <CircleAlertIcon className={"w-4 h-4 text-amber-600"} />
                              <span className={"text-sm font-medium text-amber-800"}>
                                {"Hardware Project Files"}
                              </span>
                            </div>
                            <p className={"text-sm text-amber-700"}>
                              {
                                "These files contain design specifications, circuit diagrams, and documentation for your hardware project."
                              }
                            </p>
                          </div>
                        )}
                        <div className={"grid gap-4 sm:gap-6 md:grid-cols-2"}>
                          {n.project_file && (
                            <div
                              className={
                                "bg-white border border-slate-200 rounded-xl sm:rounded-2xl p-4 sm:p-6 hover:shadow-lg transition-all duration-300"
                              }
                            >
                              <div className={"flex items-center mb-3 sm:mb-4"}>
                                <div
                                  className={
                                    "w-10 h-10 sm:w-12 sm:h-12 bg-gradient-to-r from-indigo-100 to-purple-100 rounded-lg sm:rounded-xl flex items-center justify-center mr-3 sm:mr-4"
                                  }
                                >
                                  <svg
                                    className={"w-5 h-5 sm:w-6 sm:h-6 text-indigo-600"}
                                    fill={"none"}
                                    stroke={"currentColor"}
                                    viewBox={"0 0 24 24"}
                                  >
                                    <path
                                      strokeLinecap={"round"}
                                      strokeLinejoin={"round"}
                                      strokeWidth={"2"}
                                      d={"M10 20l4-16m4 4l4 4-4 4M6 16l-4-4 4-4"}
                                    />
                                  </svg>
                                </div>
                                <div>
                                  <h3 className={"font-bold text-slate-800 text-sm sm:text-base"}>
                                    {R ? "Design Files" : "Project Files"}
                                  </h3>
                                  <p className={"text-slate-600 text-xs sm:text-sm"}>
                                    {R
                                      ? "Circuit diagrams and specifications"
                                      : "Source code and project assets"}
                                  </p>
                                </div>
                              </div>
                              <p className={"text-slate-600 text-xs sm:text-sm mb-4 sm:mb-6"}>
                                {R
                                  ? "Contains circuit diagrams, PCB layouts, component lists, and design specifications."
                                  : "Contains all source code, assets, and project configuration files."}
                              </p>
                              <button
                                className={`w-full inline-flex items-center justify-center px-4 sm:px-6 py-2.5 sm:py-3 rounded-lg sm:rounded-xl shadow-md font-medium transition-all duration-300 text-sm sm:text-base ${f.project === "idle" ? "bg-gradient-to-r from-indigo-600 to-purple-600 hover:from-indigo-700 hover:to-purple-700 text-white hover:shadow-lg" : f.project === "success" ? "bg-green-500 text-white" : f.project === "error" ? "bg-red-500 text-white" : "bg-slate-400 text-white"} ${f.project !== "idle" ? "opacity-75" : ""}`}
                                onClick={() => C("project")}
                                disabled={f.project !== "idle"}
                              >
                                {f.project === "loading" && (
                                  <svg
                                    className={
                                      "animate-spin -ml-1 mr-2 sm:mr-3 h-3 w-3 sm:h-4 sm:w-4"
                                    }
                                    xmlns={"http://www.w3.org/2000/svg"}
                                    fill={"none"}
                                    viewBox={"0 0 24 24"}
                                  >
                                    <circle
                                      className={"opacity-25"}
                                      cx={"12"}
                                      cy={"12"}
                                      r={"10"}
                                      stroke={"currentColor"}
                                      strokeWidth={"4"}
                                    />
                                    <path
                                      className={"opacity-75"}
                                      fill={"currentColor"}
                                      d={
                                        "M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                                      }
                                    />
                                  </svg>
                                )}
                                {f.project === "success" && (
                                  <svg
                                    className={"-ml-1 mr-2 sm:mr-3 h-3 w-3 sm:h-4 sm:w-4"}
                                    fill={"none"}
                                    stroke={"currentColor"}
                                    viewBox={"0 0 24 24"}
                                  >
                                    <path
                                      strokeLinecap={"round"}
                                      strokeLinejoin={"round"}
                                      strokeWidth={"2"}
                                      d={"M5 13l4 4L19 7"}
                                    />
                                  </svg>
                                )}
                                {f.project === "error" && (
                                  <svg
                                    className={"-ml-1 mr-2 sm:mr-3 h-3 w-3 sm:h-4 sm:w-4"}
                                    fill={"none"}
                                    stroke={"currentColor"}
                                    viewBox={"0 0 24 24"}
                                  >
                                    <path
                                      strokeLinecap={"round"}
                                      strokeLinejoin={"round"}
                                      strokeWidth={"2"}
                                      d={"M6 18L18 6M6 6l12 12"}
                                    />
                                  </svg>
                                )}
                                {A(f.project, R ? "Design Files" : "Project Files")}
                              </button>
                            </div>
                          )}
                          {n.report_file && (
                            <div
                              className={
                                "bg-white border border-slate-200 rounded-xl sm:rounded-2xl p-4 sm:p-6 hover:shadow-lg transition-all duration-300"
                              }
                            >
                              <div className={"flex items-center mb-3 sm:mb-4"}>
                                <div
                                  className={
                                    "w-10 h-10 sm:w-12 sm:h-12 bg-gradient-to-r from-green-100 to-blue-100 rounded-lg sm:rounded-xl flex items-center justify-center mr-3 sm:mr-4"
                                  }
                                >
                                  <svg
                                    className={"w-5 h-5 sm:w-6 sm:h-6 text-green-600"}
                                    fill={"none"}
                                    stroke={"currentColor"}
                                    viewBox={"0 0 24 24"}
                                  >
                                    <path
                                      strokeLinecap={"round"}
                                      strokeLinejoin={"round"}
                                      strokeWidth={"2"}
                                      d={
                                        "M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"
                                      }
                                    />
                                  </svg>
                                </div>
                                <div>
                                  <h3 className={"font-bold text-slate-800 text-sm sm:text-base"}>
                                    {"Report & Documentation"}
                                  </h3>
                                  <p className={"text-slate-600 text-xs sm:text-sm"}>
                                    {"Complete project documentation"}
                                  </p>
                                </div>
                              </div>
                              <p className={"text-slate-600 text-xs sm:text-sm mb-4 sm:mb-6"}>
                                {R
                                  ? "Contains project documentation, assembly instructions, and technical reports."
                                  : "Contains project documentation, setup guides, and detailed explanations."}
                              </p>
                              <button
                                className={`w-full inline-flex items-center justify-center px-4 sm:px-6 py-2.5 sm:py-3 rounded-lg sm:rounded-xl shadow-md font-medium transition-all duration-300 text-sm sm:text-base ${f.report === "idle" ? "bg-gradient-to-r from-green-600 to-blue-600 hover:from-green-700 hover:to-blue-700 text-white hover:shadow-lg" : f.report === "success" ? "bg-green-500 text-white" : f.report === "error" ? "bg-red-500 text-white" : "bg-slate-400 text-white"} ${f.report !== "idle" ? "opacity-75" : ""}`}
                                onClick={() => C("report")}
                                disabled={f.report !== "idle"}
                              >
                                {f.report === "loading" && (
                                  <svg
                                    className={
                                      "animate-spin -ml-1 mr-2 sm:mr-3 h-3 w-3 sm:h-4 sm:w-4"
                                    }
                                    xmlns={"http://www.w3.org/2000/svg"}
                                    fill={"none"}
                                    viewBox={"0 0 24 24"}
                                  >
                                    <circle
                                      className={"opacity-25"}
                                      cx={"12"}
                                      cy={"12"}
                                      r={"10"}
                                      stroke={"currentColor"}
                                      strokeWidth={"4"}
                                    />
                                    <path
                                      className={"opacity-75"}
                                      fill={"currentColor"}
                                      d={
                                        "M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                                      }
                                    />
                                  </svg>
                                )}
                                {f.report === "success" && (
                                  <svg
                                    className={"-ml-1 mr-2 sm:mr-3 h-3 w-3 sm:h-4 sm:w-4"}
                                    fill={"none"}
                                    stroke={"currentColor"}
                                    viewBox={"0 0 24 24"}
                                  >
                                    <path
                                      strokeLinecap={"round"}
                                      strokeLinejoin={"round"}
                                      strokeWidth={"2"}
                                      d={"M5 13l4 4L19 7"}
                                    />
                                  </svg>
                                )}
                                {f.report === "error" && (
                                  <svg
                                    className={"-ml-1 mr-2 sm:mr-3 h-3 w-3 sm:h-4 sm:w-4"}
                                    fill={"none"}
                                    stroke={"currentColor"}
                                    viewBox={"0 0 24 24"}
                                  >
                                    <path
                                      strokeLinecap={"round"}
                                      strokeLinejoin={"round"}
                                      strokeWidth={"2"}
                                      d={"M6 18L18 6M6 6l12 12"}
                                    />
                                  </svg>
                                )}
                                {A(f.report, "Report")}
                              </button>
                            </div>
                          )}
                        </div>
                      </motion.div>
                    )}
                    <div className={"grid grid-cols-1 md:grid-cols-2 gap-4 sm:gap-6"}>
                      {n.features && (
                        <div
                          className={
                            "bg-white border border-slate-200 rounded-xl sm:rounded-2xl p-4 sm:p-6"
                          }
                        >
                          <h3
                            className={
                              "font-bold text-slate-800 mb-3 sm:mb-4 flex items-center text-sm sm:text-base"
                            }
                          >
                            <span className={"w-2 h-2 bg-indigo-500 rounded-full mr-2"} />
                            {"Features"}
                          </h3>
                          <ul className={"space-y-1.5 sm:space-y-2"}>
                            {n.features.split(",").map((B, G) => (
                              <li
                                key={G}
                                className={"flex items-start text-slate-700 text-sm sm:text-base"}
                              >
                                <span
                                  className={
                                    "w-1.5 h-1.5 bg-slate-400 rounded-full mt-2 mr-2 sm:mr-3 flex-shrink-0"
                                  }
                                />
                                {B.trim()}
                              </li>
                            ))}
                          </ul>
                        </div>
                      )}
                      {n.language && (
                        <div
                          className={
                            "bg-white border border-slate-200 rounded-xl sm:rounded-2xl p-4 sm:p-6"
                          }
                        >
                          <h3
                            className={
                              "font-bold text-slate-800 mb-3 sm:mb-4 flex items-center text-sm sm:text-base"
                            }
                          >
                            <span className={"w-2 h-2 bg-purple-500 rounded-full mr-2"} />
                            {"Technologies"}
                          </h3>
                          <div className={"flex flex-wrap gap-1.5 sm:gap-2"}>
                            {n.language.split(",").map((B, G) => (
                              <span
                                key={G}
                                className={
                                  "px-2 sm:px-3 py-1 sm:py-1.5 bg-slate-100 text-slate-800 text-xs sm:text-sm rounded-lg font-medium"
                                }
                              >
                                {B.trim()}
                              </span>
                            ))}
                            <span
                              className={
                                "px-2 sm:px-3 py-1 sm:py-1.5 bg-indigo-100 text-indigo-800 text-xs sm:text-sm rounded-lg font-medium"
                              }
                            >
                              {n.category === "hardware"
                                ? "Hardware"
                                : n.category === "software"
                                  ? "Software"
                                  : n.category}
                            </span>
                          </div>
                        </div>
                      )}
                    </div>
                  </motion.div>
                </motion.div>
                {n.instructions && (
                  <motion.div
                    variants={O}
                    initial={"hidden"}
                    animate={"visible"}
                    className={"mb-8 sm:mb-10"}
                  >
                    <h2
                      className={
                        "text-xl sm:text-2xl font-bold text-slate-800 mb-4 sm:mb-6 flex items-center"
                      }
                    >
                      <span
                        className={
                          "w-6 h-6 sm:w-8 sm:h-8 bg-gradient-to-r from-indigo-500 to-purple-500 rounded-lg flex items-center justify-center mr-2 sm:mr-3"
                        }
                      >
                        <svg
                          className={"w-3 h-3 sm:w-4 sm:h-4 text-white"}
                          fill={"none"}
                          stroke={"currentColor"}
                          viewBox={"0 0 24 24"}
                        >
                          <path
                            strokeLinecap={"round"}
                            strokeLinejoin={"round"}
                            strokeWidth={"2"}
                            d={
                              "M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"
                            }
                          />
                        </svg>
                      </span>
                      {"Instructions"}
                    </h2>
                    <div
                      className={
                        "bg-gradient-to-br from-slate-50 to-indigo-50 rounded-xl sm:rounded-2xl p-6 sm:p-8 border border-slate-200"
                      }
                    >
                      <p
                        className={
                          "text-slate-700 leading-relaxed whitespace-pre-line text-sm sm:text-base"
                        }
                      >
                        {n.instructions}
                      </p>
                    </div>
                  </motion.div>
                )}
                {Y.length > 0 && (
                  <motion.div
                    variants={O}
                    initial={"hidden"}
                    animate={"visible"}
                    className={"mb-8 sm:mb-10"}
                  >
                    <h2
                      className={
                        "text-xl sm:text-2xl font-bold text-slate-800 mb-4 sm:mb-6 flex items-center"
                      }
                    >
                      <span
                        className={
                          "w-6 h-6 sm:w-8 sm:h-8 bg-gradient-to-r from-purple-500 to-pink-500 rounded-lg flex items-center justify-center mr-2 sm:mr-3"
                        }
                      >
                        <svg
                          className={"w-3 h-3 sm:w-4 sm:h-4 text-white"}
                          fill={"none"}
                          stroke={"currentColor"}
                          viewBox={"0 0 24 24"}
                        >
                          <path
                            strokeLinecap={"round"}
                            strokeLinejoin={"round"}
                            strokeWidth={"2"}
                            d={
                              "M8.228 9c.549-1.165 2.03-2 3.772-2 2.21 0 4 1.343 4 3 0 1.4-1.278 2.575-3.006 2.907-.542.104-.994.54-.994 1.093m0 3h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                            }
                          />
                        </svg>
                      </span>
                      {"Frequently Asked Questions"}
                    </h2>
                    <div className={"space-y-3 sm:space-y-4"}>
                      {Y.map((B, G) => (
                        <motion.div
                          key={G}
                          initial={{
                            opacity: 0,
                            y: 10,
                          }}
                          animate={{
                            opacity: 1,
                            y: 0,
                          }}
                          transition={{
                            delay: G * 0.1,
                          }}
                          className={
                            "bg-white border border-slate-200 rounded-xl sm:rounded-2xl p-4 sm:p-6 hover:shadow-md transition-shadow"
                          }
                        >
                          <h3
                            className={"font-bold text-slate-800 mb-2 sm:mb-3 text-sm sm:text-base"}
                          >
                            {B.question}
                          </h3>
                          <p
                            className={
                              "text-slate-700 leading-relaxed text-sm sm:text-base whitespace-pre-line"
                            }
                          >
                            {B.answer}
                          </p>
                        </motion.div>
                      ))}
                    </div>
                  </motion.div>
                )}
                <motion.div
                  variants={O}
                  initial={"hidden"}
                  animate={"visible"}
                  className={
                    "bg-gradient-to-br from-slate-50 to-indigo-50 rounded-xl sm:rounded-2xl p-6 sm:p-8 border border-slate-200"
                  }
                >
                  <h2
                    className={
                      "text-lg sm:text-xl font-bold text-slate-800 mb-4 sm:mb-6 flex items-center"
                    }
                  >
                    <span
                      className={
                        "w-5 h-5 sm:w-6 sm:h-6 bg-gradient-to-r from-indigo-500 to-purple-500 rounded-lg flex items-center justify-center mr-2 sm:mr-3"
                      }
                    >
                      <svg
                        className={"w-2.5 h-2.5 sm:w-3 sm:h-3 text-white"}
                        fill={"none"}
                        stroke={"currentColor"}
                        viewBox={"0 0 24 24"}
                      >
                        <path
                          strokeLinecap={"round"}
                          strokeLinejoin={"round"}
                          strokeWidth={"2"}
                          d={"M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"}
                        />
                      </svg>
                    </span>
                    {"Purchase Information"}
                  </h2>
                  <div
                    className={`grid grid-cols-1 sm:grid-cols-2 ${R ? "lg:grid-cols-3" : "lg:grid-cols-5"} gap-3 sm:gap-4 lg:gap-6`}
                  >
                    <div
                      className={
                        "bg-white rounded-lg sm:rounded-xl p-3 sm:p-4 border border-slate-200"
                      }
                    >
                      <p className={"text-xs sm:text-sm text-slate-500 mb-1"}>{"Purchase ID"}</p>
                      <p className={"font-bold text-slate-800 text-sm sm:text-base break-all"}>
                        {n.id}
                      </p>
                    </div>
                    <div
                      className={
                        "bg-white rounded-lg sm:rounded-xl p-3 sm:p-4 border border-slate-200"
                      }
                    >
                      <p className={"text-xs sm:text-sm text-slate-500 mb-1"}>{"Product ID"}</p>
                      <p className={"font-bold text-slate-800 text-sm sm:text-base"}>
                        {n.product_id}
                      </p>
                    </div>
                    <div
                      className={
                        "bg-white rounded-lg sm:rounded-xl p-3 sm:p-4 border border-slate-200"
                      }
                    >
                      <p className={"text-xs sm:text-sm text-slate-500 mb-1"}>{"Purchase Date"}</p>
                      <p className={"font-bold text-slate-800 text-sm sm:text-base"}>
                        {n.purchase_date}
                      </p>
                    </div>
                    <div
                      className={
                        "bg-white rounded-lg sm:rounded-xl p-3 sm:p-4 border border-slate-200"
                      }
                    >
                      <p className={"text-xs sm:text-sm text-slate-500 mb-1"}>
                        {"Purchase Amount"}
                      </p>
                      <p className={"font-bold text-slate-800 text-sm sm:text-base"}>
                        {n.final_amount}
                      </p>
                    </div>
                    <div
                      className={
                        "bg-white rounded-lg sm:rounded-xl p-3 sm:p-4 border border-slate-200"
                      }
                    >
                      <p className={"text-xs sm:text-sm text-slate-500 mb-1"}>{"Status"}</p>
                      <span
                        className={
                          "inline-flex items-center px-2 sm:px-3 py-1 rounded-full text-xs font-semibold bg-green-100 text-green-800"
                        }
                      >
                        <span className={"w-2 h-2 bg-green-500 rounded-full mr-1 sm:mr-2"} />
                        {"Paid"}
                      </span>
                    </div>
                    {R && (
                      <jsxRuntime.Fragment>
                        <div
                          className={
                            "bg-white rounded-lg sm:rounded-xl p-3 sm:p-4 border border-slate-200"
                          }
                        >
                          <p className={"text-xs sm:text-sm text-slate-500 mb-1"}>
                            {"Project Type"}
                          </p>
                          <span
                            className={
                              "inline-flex items-center px-2 sm:px-3 py-1 rounded-full text-xs font-semibold bg-orange-100 text-orange-800"
                            }
                          >
                            <PackageIcon className={"w-3 h-3 mr-1"} />
                            {"Hardware"}
                          </span>
                        </div>
                        <div
                          className={
                            "bg-white rounded-lg sm:rounded-xl p-3 sm:p-4 border border-slate-200"
                          }
                        >
                          <p className={"text-xs sm:text-sm text-slate-500 mb-1"}>
                            {"Delivery Status"}
                          </p>
                          <span
                            className={`inline-flex items-center px-2 sm:px-3 py-1 rounded-full text-xs font-semibold ${U == null ? undefined : U.bgColor} ${U == null ? undefined : U.textColor}`}
                          >
                            <span className={"w-2 h-2 bg-current rounded-full mr-1 sm:mr-2"} />
                            {(U == null ? undefined : U.text) || "Unknown"}
                          </span>
                        </div>
                      </jsxRuntime.Fragment>
                    )}
                  </div>
                </motion.div>
              </div>
            </motion.div>
            <div className={"mt-6 sm:mt-8"}>
              <CertificateRequestCard purchaseId={n.id} />
            </div>
            <motion.button
              initial={{
                scale: 0,
              }}
              animate={{
                scale: 1,
              }}
              transition={{
                delay: 0.5,
              }}
              onClick={() => g(!p)}
              className={
                "fixed left-3 bottom-4 sm:bottom-6 bg-gradient-to-r from-indigo-600 to-purple-600 text-white rounded-xl sm:rounded-2xl p-3 sm:p-4 shadow-xl hover:shadow-2xl hover:scale-105 transition-all duration-300 z-10 flex items-center group"
              }
            >
              {p ? (
                <jsxRuntime.Fragment>
                  <svg
                    className={"w-5 h-5 sm:w-6 sm:h-6"}
                    fill={"none"}
                    stroke={"currentColor"}
                    viewBox={"0 0 24 24"}
                  >
                    <path
                      strokeLinecap={"round"}
                      strokeLinejoin={"round"}
                      strokeWidth={"2"}
                      d={"M6 18L18 6M6 6l12 12"}
                    />
                  </svg>
                  <span
                    className={"ml-2 sm:ml-3 font-medium hidden sm:block group-hover:block text-sm"}
                  >
                    {"Close Chat"}
                  </span>
                </jsxRuntime.Fragment>
              ) : (
                <jsxRuntime.Fragment>
                  <svg
                    className={"w-5 h-5 sm:w-6 sm:h-6"}
                    fill={"none"}
                    stroke={"currentColor"}
                    viewBox={"0 0 24 24"}
                  >
                    <path
                      strokeLinecap={"round"}
                      strokeLinejoin={"round"}
                      strokeWidth={"2"}
                      d={
                        "M8 12h.01M12 12h.01M16 12h.01M21 12c0 4.418-4.03 8-9 8a9.863 9.863 0 01-4.255-.949L3 20l1.395-3.72C3.512 15.042 3 13.574 3 12c0-4.418 4.03-8 9-8s9 3.582 9 8z"
                      }
                    />
                  </svg>
                  <span
                    className={"ml-2 sm:ml-3 font-medium hidden sm:block group-hover:block text-sm"}
                  >
                    {"CodeBruh Support"}
                  </span>
                </jsxRuntime.Fragment>
              )}
            </motion.button>
            {p && (
              <motion.div
                initial={{
                  opacity: 0,
                  y: 50,
                  scale: 0.9,
                }}
                animate={{
                  opacity: 1,
                  y: 0,
                  scale: 1,
                }}
                exit={{
                  opacity: 0,
                  y: 50,
                  scale: 0.9,
                }}
                className={
                  "fixed bottom-16 sm:bottom-24 right-4 sm:right-6 w-72 sm:w-80 md:w-96 z-10 shadow-2xl rounded-xl sm:rounded-2xl overflow-hidden"
                }
              >
                <ProductSupportChat
                  productId={n.product_id}
                  userId={(y == null ? undefined : y.id) || ""}
                />
              </motion.div>
            )}
          </div>
        ) : (
          <motion.div
            initial={{
              opacity: 0,
              y: 20,
            }}
            animate={{
              opacity: 1,
              y: 0,
            }}
            className={
              "bg-white rounded-2xl sm:rounded-3xl shadow-xl p-8 sm:p-12 text-center border border-slate-100"
            }
          >
            <div
              className={
                "w-20 h-20 sm:w-24 sm:h-24 bg-gradient-to-br from-slate-100 to-slate-200 rounded-full flex items-center justify-center mx-auto mb-4 sm:mb-6"
              }
            >
              <svg
                className={"w-10 h-10 sm:w-12 sm:h-12 text-slate-400"}
                fill={"none"}
                stroke={"currentColor"}
                viewBox={"0 0 24 24"}
              >
                <path
                  strokeLinecap={"round"}
                  strokeLinejoin={"round"}
                  strokeWidth={"2"}
                  d={
                    "M9.172 16.172a4 4 0 015.656 0M9 10h.01M15 10h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                  }
                />
              </svg>
            </div>
            <h2 className={"text-xl sm:text-2xl font-bold text-slate-700 mb-3 sm:mb-4"}>
              {"Purchase Not Found"}
            </h2>
            <p className={"text-slate-600 mb-6 sm:mb-8 max-w-md mx-auto text-sm sm:text-base"}>
              {"The purchase you're looking for doesn't exist or you don't have access to it."}
            </p>
            <Button
              variant={"primary"}
              onClick={() => b("/my")}
              className={
                "px-6 sm:px-8 py-2.5 sm:py-3 bg-gradient-to-r from-indigo-600 to-purple-600 hover:from-indigo-700 hover:to-purple-700 text-white rounded-lg sm:rounded-xl font-medium shadow-lg hover:shadow-xl transition-all duration-300 text-sm sm:text-base"
              }
            >
              {"Return to My Purchases"}
            </Button>
          </motion.div>
        )}
      </div>
    </div>
  );
};
export { PurchaseDetailsPage };
